import { render, staticRenderFns } from "./DeleteProjectDialog.vue?vue&type=template&id=62c5af30&scoped=true&"
import script from "./DeleteProjectDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteProjectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteProjectDialog.vue?vue&type=style&index=0&id=62c5af30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c5af30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
